module.exports = __webpack_public_path__ + "img/stephen-girard.ffae8bcc.jpg";